import React from 'react';
import { Box, useTheme } from '@mui/material';
import { keyframes } from '@emotion/react';

const moveAcross = keyframes`
  0% { left: 0; }
  50% { left: calc(100% - 10px); } /* subtract dot width */
  100% { left: 0; }
`;

const MovingDot = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: 10,
        overflow: 'hidden',
        // backgroundColor: '#f0f0f0',
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 2,
          borderRadius: '25%',
          position: 'absolute',
          backgroundColor: theme.palette.primary.main,
          animation: `${moveAcross} 3s infinite ease-in-out`,
        }}
      />
    </Box>
  );
};

export default MovingDot;
